import React, { useState, useEffect, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import temperatureLineIcon from "../../../../assets/images/weather_icon/temperature_line.png";
import windspeedLineIcon from "../../../../assets/images/weather_icon/windspeed_line.png";
import precipitationLineIcon from "../../../../assets/images/weather_icon/precipitation_line.png";
import humidityLineIcon from "../../../../assets/images/weather_icon/humidity_line.png";
// Light 테마용 아이콘들 추가
import windspeedLineLightIcon from "../../../../assets/images/weather_icon/windspeed_line_light.png";
import precipitationLineLightIcon from "../../../../assets/images/weather_icon/precipitation_line_light.png";
import humidityLineLightIcon from "../../../../assets/images/weather_icon/humidity_line_light.png";
// import backgroundImage from "../../../../assets/images/weather_icon/nature_bg.png";
import { useAtom } from "jotai";
import {
  AUTODISPLAY_TITLE,
  AUTODISPLAY_TEXT_DATA,
  AUTODISPLAY_LOCATION_DATA,
  AUTODISPLAY_DESIGN_CONCEPT,
  AUTODISPLAY_SENSOR_DATA,
  AUTODISPLAY_INTERVER_TIME,
  AUTODISPLAY_REACT_STATE,
  AUTODISPLAY_DISPLAY_WIDTH,
  AUTODISPLAY_DISPLAY_HEIGHT,
} from "../../../AtomStates";
import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";
import {
  getPlalionSensorData,
  getWeatherData,
  getWeatherForecastData,
  getOpenWeatherData,
} from "../../../../utils/indexedDB";
import AtomsGauge from "../atoms/AtomsGauge";
import { palette } from "../../../../assets/styles/Palette";
import { Button } from "../../../../assets/styles/ButtonStyle";
import MoleculeSizeArea from "../molecules/MoleculeSizeArea";
import MoleculeModeFloating from "../molecules/MoleculeModeFloating";

import qhdBackground from "../../../../assets/images/Background/Info_background.png";

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 4em));
  }
`;

const thermoLineIcon = temperatureLineIcon;

// 날씨 아이콘 매핑 객체
const weatherIcons = {
  // 기싱청 아이콘
  S10: s10Icon,
  S11: s11Icon,
  S12: s12Icon,
  S13: s13Icon,
  S14: s14Icon,
  S15: s15Icon,
  S16: s16Icon,
  S17: s17Icon,
  S30: s30Icon,
  S31: s31Icon,
  S32: s32Icon,
  S33: s33Icon,
  S34: s34Icon,
  S35: s35Icon,
  S36: s36Icon,
  S37: s37Icon,
  S40: s40Icon,
  S41: s41Icon,
  S42: s42Icon,
  S43: s43Icon,
  S44: s44Icon,
  S45: s45Icon,
  S46: s46Icon,
  S47: s47Icon,

  // OpenWeather 아이콘
  '01d': s10Icon, // 맑음 낮
  '01n': s10Icon, // 맑음 밤
  '02d': s30Icon, // 구름 조금 낮
  '02n': s30Icon, // 구름 조금 밤
  '03d': s40Icon, // 구름 많음 낮
  '03n': s40Icon, // 구름 많음 밤
  '04d': s40Icon, // 구름 매우 많음 낮
  '04n': s40Icon, // 구름 매우 많음 밤
  '09d': s41Icon, // 소나기 낮
  '09n': s41Icon, // 소나기 밤
  '10d': s31Icon, // 비 낮
  '10n': s31Icon, // 비 밤
  '11d': s40Icon, // 뇌우 낮
  '11n': s40Icon, // 뇌우 밤
  '13d': s43Icon, // 눈 낮
  '13n': s43Icon, // 눈 밤
  '50d': s40Icon, // 안개 낮
  '50n': s40Icon, // 안개 밤
};

// 아이콘 코드로 실제 아이콘 이미지 가져오기
const getWeatherIconImage = (iconCode) => {
  return weatherIcons[iconCode] || s10Icon;
};

// Helper for responsive units - 기본 스케일링 (가로 기준) 순수 비율만
const r = (value) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  return `min(${(value / baseWidth) * 100}vw, ${(value / baseHeight) * 100}vh)`;
};

// Helper for responsive units - 세로 비율이 긴 경우 VH 기준 스케일링 순수 비율만
const rv = (value) => {
  const baseHeight = 1080;

  return `${(value / baseHeight) * 100}vh`;
};

// 테마별 컬러 매핑 객체
const themeColors = {
  dark: {
    mainColor: "white",
    MainContainerBackgroundLinearGradient01: "rgba(0, 0, 0, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(0, 0, 0, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(0, 0, 0, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(0, 0, 0, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(0, 0, 0, 0.3)",
    WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(255, 255, 255, 0.6)",
    bottomMessageBackground: "rgba(255, 255, 255, 0.2)",
  },
  light: {
    mainColor: "black",
    MainContainerBackgroundLinearGradient01: "rgba(255, 255, 255, 0.4)",
    MainContainerBackgroundLinearGradient02: "rgba(255, 255, 255, 0.4)",
    MainPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    MainPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    MainPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    MainPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherPanelBackgroundLinearGradient01: "rgba(255, 255, 255, 0.3)",
    WeatherPanelBackgroundLinearGradient02: "rgba(255, 255, 255, 0.5)",
    WeatherPanelBackgroundLinearGradient03: "rgba(255, 255, 255, 0.3)",
    WeatherPanelOutline: "rgba(255, 255, 255, 0.4)",
    WeatherLabelColor: "rgba(0, 0, 0, 0.6)",
    bottomMessageBackground: "rgba(0, 0, 0, 0.2)",
  },
};

/**
 * 테마모드에 따른 색상을 가져오는 함수
 * @param {string} colorName - 색상 이름 (예: "mainColor", "MainPanelOutline")
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 색상 값
 */
const getThemeColor = (colorName, themeMode = "dark") => {
  const theme = themeColors[themeMode] || themeColors.dark;
  return theme[colorName] || themeColors.dark[colorName];
};

/**
 * 테마모드에 따른 날씨 아이콘을 가져오는 함수
 * @param {string} iconType - 아이콘 타입 ("windspeed", "precipitation", "humidity")
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 아이콘 경로
 */
const getWeatherThemeIcon = (iconType, themeMode = "dark") => {
  const weatherIconThemes = {
    dark: {
      windspeed: windspeedLineIcon,
      precipitation: precipitationLineIcon,
      humidity: humidityLineIcon,
    },
    light: {
      windspeed: windspeedLineLightIcon,
      precipitation: precipitationLineLightIcon,
      humidity: humidityLineLightIcon,
    },
  };

  const theme = weatherIconThemes[themeMode] || weatherIconThemes.dark;
  return theme[iconType] || weatherIconThemes.dark[iconType];
};

const OrganismInfoDisplayViewCustomPreview = ({ onClose }) => {
  const navigate = useNavigate();
  const [title] = useAtom(AUTODISPLAY_TITLE);
  const [textData] = useAtom(AUTODISPLAY_TEXT_DATA);
  const [locationData] = useAtom(AUTODISPLAY_LOCATION_DATA);
  const [designConcept] = useAtom(AUTODISPLAY_DESIGN_CONCEPT);
  const [sensorSerialData] = useAtom(AUTODISPLAY_SENSOR_DATA);

  // atom에서 해상도 및 반응형 모드 정보 가져오기
  const [reactState] = useAtom(AUTODISPLAY_REACT_STATE);
  const [displayWidth] = useAtom(AUTODISPLAY_DISPLAY_WIDTH);
  const [displayHeight] = useAtom(AUTODISPLAY_DISPLAY_HEIGHT);
  const [autodisplayIntervalTime] = useAtom(AUTODISPLAY_INTERVER_TIME);

  // 고정 모드 조건을 더 명확하게 체크
  const isFixedMode =
    reactState === "fixed" && displayWidth > 0 && displayHeight > 0;

  // 테마 모드 결정 (실제 컴포넌트와 동일한 로직)
  const themeMode = designConcept[0] === "다크 모드" ? "dark" : "light";

  const [orientation, setOrientation] = useState("landscape");
  const [isWider, setIsWider] = useState(false);
  const [isTaller, setIsTaller] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());

  const [weatherData, setWeatherData] = useState({
    temperature: "-",
    wind: "-",
    precipitation: "-",
    humidity: "-",
    pty: "-", // 강수형태 추가
  });
  const [sensorData, setSensorData] = useState({
    ozone: "0",
    temperature: "23",
    humidity: "55",
    dust: "0",
    voc: "3",
    co2: "403",
  });
  const lastWeatherUpdateHourRef = useRef(null);

  const [weatherForecastData, setWeatherForecastData] = useState({
    maxTemperature: "-",
    minTemperature: "-",
    sky: "-",
  });
  const [lastTempUpdateDate, setLastTempUpdateDate] = useState(null); // TMX, TMN 마지막 업데이트 날짜

  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const messageContainerRef = useRef(null);
  const messageTextRef = useRef(null);

  // 날씨 예보 API 파라미터 계산 함수
  const calculateForecastParams = (currentTime) => {
    const year = currentTime.getFullYear();
    const month = String(currentTime.getMonth() + 1).padStart(2, "0");
    const day = String(currentTime.getDate()).padStart(2, "0");
    const hour = currentTime.getHours();

    // API 발표 시간 기준
    let baseTime;
    if (hour >= 23) {
      baseTime = "2300";
    } else if (hour >= 20) {
      baseTime = "2000";
    } else if (hour >= 17) {
      baseTime = "1700";
    } else if (hour >= 14) {
      baseTime = "1400";
    } else if (hour >= 11) {
      baseTime = "1100";
    } else if (hour >= 8) {
      baseTime = "0800";
    } else if (hour >= 5) {
      baseTime = "0500";
    } else {
      baseTime = "0200";
    }

    // 새벽 시간대는 전날 데이터 사용
    let baseDate;
    if (hour < 2) {
      const yesterday = new Date(currentTime);
      yesterday.setDate(yesterday.getDate() - 1);
      baseDate = `${yesterday.getFullYear()}${String(
        yesterday.getMonth() + 1
      ).padStart(2, "0")}${String(yesterday.getDate()).padStart(2, "0")}`;
      baseTime = "2300";
    } else {
      baseDate = `${year}${month}${day}`;
    }

    return {
      pageNo: 1,
      base_date: baseDate,
      base_time: baseTime,
    };
  };

  // 날씨 예보 데이터 가져오기
  const fetchWeatherForecast = async () => {
    try {
      const now = new Date();
      const params = calculateForecastParams(now);

      const forecastParams = {
        pageNo: params.pageNo,
        numOfRows: 12,
        dataType: "JSON",
        base_date: params.base_date,
        base_time: params.base_time,
        nx: locationData?.selectedDistricts?.x,
        ny: locationData?.selectedDistricts?.y,
      };

      const response = await getWeatherForecastData(forecastParams);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const forecast = {};

        items.forEach((item) => {
          switch (item.category) {
            case "SKY": // 하늘 상태
              forecast.sky = item.fcstValue;
              break;
          }
        });

        setWeatherForecastData((prev) => ({ ...prev, ...forecast }));
      }
    } catch (error) {
      console.error("날씨 예보 데이터 가져오기 실패:", error);
    }
  };

  // TMX, TMN 데이터 가져오기 (매일 02시 기준)
  const fetchTemperatureMinMax = async () => {
    try {
      const now = new Date();
      const currentDate = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;

      // 이미 오늘 업데이트했다면 스킵
      if (lastTempUpdateDate === currentDate) {
        console.log("TMX, TMN 데이터는 이미 오늘 업데이트됨");
        return;
      }

      const tempParams = {
        pageNo: 1,
        numOfRows: 300,
        dataType: "JSON",
        base_date: currentDate,
        base_time: "0200",
        nx: locationData?.selectedDistricts?.x,
        ny: locationData?.selectedDistricts?.y,
      };

      const response = await getWeatherForecastData(tempParams);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const tempData = {};

        // 오늘 날짜의 TMX, TMN 찾기
        items.forEach((item) => {
          if (item.fcstDate === currentDate) {
            switch (item.category) {
              case "TMX": // 최고 기온
                tempData.maxTemperature = item.fcstValue;
                break;
              case "TMN": // 최저 기온
                tempData.minTemperature = item.fcstValue;
                break;
            }
          }
        });

        // 데이터가 있으면 업데이트
        if (tempData.maxTemperature || tempData.minTemperature) {
          setWeatherForecastData((prev) => ({ ...prev, ...tempData }));
          setLastTempUpdateDate(currentDate);
          console.log("TMX, TMN 데이터 업데이트 완료:", tempData);
        }
      }
    } catch (error) {
      console.error("TMX, TMN 데이터 가져오기 실패:", error);
    }
  };

  // 현재 온도와 최대/최저 온도 비교하여 업데이트
  useEffect(() => {
    if (
      weatherData.temperature &&
      (weatherForecastData.maxTemperature || weatherForecastData.minTemperature)
    ) {
      const currentTemp = parseFloat(weatherData.temperature);
      let shouldUpdate = false;
      let updateData = {};

      // 최대 온도 체크
      if (weatherForecastData.maxTemperature) {
        const maxTemp = parseFloat(weatherForecastData.maxTemperature);
        if (currentTemp > maxTemp) {
          updateData.maxTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      // 최저 온도 체크
      if (weatherForecastData.minTemperature) {
        const minTemp = parseFloat(weatherForecastData.minTemperature);
        if (currentTemp < minTemp) {
          updateData.minTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        setWeatherForecastData((prev) => ({
          ...prev,
          ...updateData,
        }));
      }
    }
  }, [
    weatherData.temperature,
    weatherForecastData.maxTemperature,
    weatherForecastData.minTemperature,
  ]);

  const fetchSensorData = async () => {
    try {
      const response = await getPlalionSensorData({
        serial_num: sensorSerialData.serialCode,
      });

      if (
        response &&
        response.code === 101 &&
        response.rows &&
        response.rows.length > 0
      ) {
        const data = response.rows[0];

        setSensorData({
          ozone: parseFloat(data.ozone_val).toFixed(3),
          temperature: parseFloat(data.temp_val),
          humidity: parseFloat(data.humi_val),
          dust: parseFloat(data.dust_val),
          voc: parseFloat(data.voc_val),
          co2: parseFloat(data.co2_val),
        });
      } else {
        setSensorData({
          ozone: "-",
          temperature: "-",
          humidity: "-",
          dust: "-",
          voc: "-",
          co2: "-",
        });
      }
    } catch (error) {
      console.error("Error fetching sensor data:", error);
      setSensorData({
        ozone: "-",
        temperature: "-",
        humidity: "-",
        dust: "-",
        voc: "-",
        co2: "-",
      });
    }
  };

    const fetchWeatherData = async () => {
    const now = new Date();
    let base_date_obj = new Date();

    let currentHour = now.getHours();
    let base_time = "";

    // 초단기실황 API는 매시 45분 이후에 데이터가 제공됩니다.
    if (now.getMinutes() < 45) {
      if (currentHour === 0) {
        base_date_obj.setDate(base_date_obj.getDate() - 1);
        base_time = "2300";
      } else {
        base_time = `${String(currentHour - 1).padStart(2, "0")}00`;
      }
    } else {
      base_time = `${String(currentHour).padStart(2, "0")}00`;
    }

    const base_date = `${base_date_obj.getFullYear()}${String(
      base_date_obj.getMonth() + 1
    ).padStart(2, "0")}${String(base_date_obj.getDate()).padStart(2, "0")}`;

    const nx = locationData?.selectedDistricts?.x;
    const ny = locationData?.selectedDistricts?.y;

    const params = {
      pageNo: 1,
      numOfRows: 10,
      dataType: "JSON",
      base_date: base_date,
      base_time: base_time,
      nx,
      ny,
    };

    try {
      const response = await getWeatherData(params);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const weather = {};
        items.forEach((item) => {
          switch (item.category) {
            case "T1H": // 기온
              weather.temperature = item.obsrValue;
              break;
            case "RN1": // 1시간 강수량
              weather.precipitation = item.obsrValue;
              break;
            case "WSD": // 풍속
              weather.wind = item.obsrValue;
              break;
            case "REH": // 습도
              weather.humidity = item.obsrValue;
              break;
            case "PTY": // 강수형태
              weather.pty = item.obsrValue;
              break;
            default:
              break;
          }
        });
        setWeatherData((prevData) => ({ ...prevData, ...weather }));
      } else {
        console.error(
          "Weather API Error:",
          response.data.response.header.resultMsg
        );
      }
    } catch (error) {
      console.error("Failed to fetch weather data:", error);
      fetchOpenWeatherData(); // OpenWeather API로 대체
    }
  };

  // OpenWeather API를 사용한 날씨 데이터 가져오기
  const fetchOpenWeatherData = async () => {
    try {
      const lat = locationData?.selectedDistricts?.lat;
      const lon = locationData?.selectedDistricts?.lon;

      if (!lat || !lon) {
        console.error("위치 정보가 없습니다.");
        return;
      }

      const params = {
        lat: lat,
        lon: lon,
      };

      const response = await getOpenWeatherData(params);

      console.log("OpenWeather API response:", response);

      if (response.data) {
        const data = response.data;

        // 현재 날씨 데이터 (One Call API)
        const weather = {
          temperature: Math.round(data.current.temp), // 현재 기온
          wind: data.current.wind_speed ? data.current.wind_speed.toFixed(1) : "0", // 풍속
          humidity: data.current.humidity, // 습도
          precipitation: data.current.rain ? (data.current.rain['1h'] || 0) : 0, // 강수량 (1시간)
        };

        // 일일 예보 데이터 (최저/최고 기온, 날씨 상태)
        const forecast = {
          minTemperature: Math.round(data.daily[0].temp.min),
          maxTemperature: Math.round(data.daily[0].temp.max),
          weatherMain: data.current.weather ? data.current.weather[0].main : "Clear",
          weatherIcon: data.current.weather ? data.current.weather[0].icon : "01d",
        };
        console.log("Parsed OpenWeather data:", { weather, forecast });

        setWeatherData(weather);
        setWeatherForecastData(forecast);
      }
    } catch (error) {
      console.error("OpenWeather 데이터 가져오기 실패:", error);
    }
  };

  useEffect(() => {
    fetchSensorData();
    // fetchWeatherData();
    fetchOpenWeatherData();
    // fetchWeatherForecast();
    // fetchTemperatureMinMax();

    const weatherTimerId = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();

      // 매시간 정각에 예보 데이터 업데이트
      if (now.getMinutes() === 0) {
        // fetchWeatherData();
        // fetchWeatherForecast();
        fetchOpenWeatherData();

        // 매일 02시에 TMX, TMN 업데이트
        // if (currentHour === 2) {
        //   fetchTemperatureMinMax();
        // }
      }
    }, 60000); // 1분마다 체크

    const sensorTimerId = setInterval(() => {
      fetchSensorData();
    }, 10 * 6 * 1000); // 10초마다 센서 데이터 업데이트

    const dateTimerId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    return () => {
      clearInterval(weatherTimerId);
      clearInterval(sensorTimerId);
      clearInterval(dateTimerId);
    };
  }, []);

  // 고정 모드일 때만 실행되는 useEffect
  useEffect(() => {
    if (reactState === "fixed" && displayWidth > 0 && displayHeight > 0) {
      const fixedRatio = displayWidth / displayHeight;
      setOrientation(fixedRatio > 1 ? "landscape" : "portrait");
      setIsWider(fixedRatio > 16 / 9);
      setIsTaller(fixedRatio < 9 / 16);
    }
  }, [reactState, displayWidth, displayHeight]);

  // 반응형 모드일 때만 실행되는 useEffect (기존과 완전히 동일)
  useEffect(() => {
    // reactState가 'active'이거나 undefined일 때만 실행 (기존 동작)
    if (reactState === "active" || reactState === undefined) {
      const handleResize = () => {
        const currentRatio = window.innerWidth / window.innerHeight;
        setOrientation(currentRatio > 1 ? "landscape" : "portrait");
        setIsWider(currentRatio > 16 / 9);
        setIsTaller(currentRatio < 9 / 16);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []); // 기존과 완전히 동일한 빈 배열

  useEffect(() => {
    const checkOverflow = () => {
      const container = messageContainerRef.current;
      const text = messageTextRef.current;
      if (container && text) {
        const isOverflow = text.scrollWidth > container.clientWidth;
        if (isOverflow !== isTextOverflowing) {
          setIsTextOverflowing(isOverflow);
        }
      }
    };

    const timer = setTimeout(checkOverflow, 100);
    window.addEventListener("resize", checkOverflow);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [textData, orientation, isWider, isTaller, isTextOverflowing]);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  // 날씨 상태에 따른 텍스트
  const getWeatherStatus = (weather) => {
    switch (weather) {
      // 기상청
      case "1":
        return "맑음";
      case "3":
        return "구름 많음";
      case "4":
        return "흐림";
        
      // OpenWeather
      case "Clear":
        return "맑음";
      case "Clouds":
        return "구름 많음";
      case "Rain":
        return "비";
      case "Drizzle":
        return "이슬비";
      case "Thunderstorm":
        return "뇌우";
      case "Snow":
        return "눈";
      case "Mist":
      case "Fog":
        return "안개";
      default:
        return "-";
    }
  };

  // SKY와 PTY 값을 조합하여 날씨 아이콘 코드 생성
  const getWeatherIconCode = (skyCode, ptyCode) => {
    return `S${skyCode}${ptyCode}`;
  };

  // 현재 날씨 아이콘 (OpenWeather icon 코드 사용)
  const currentWeatherIcon = weatherForecastData.sky && weatherForecastData.pyt ? 
    getWeatherIconCode(
      weatherForecastData.sky,
      weatherData.pty
    ) : weatherForecastData.weatherIcon;

  // 체감온도 계산 함수
  const calculateFeelsLike = (temperature, humidity, windSpeed) => {
    const temp = parseFloat(temperature);
    const humid = parseFloat(humidity);
    const wind = parseFloat(windSpeed);

    // 온도가 26.7°C 이상일 때: Heat Index 사용
    if (temp >= 26.7) {
      const tempF = (temp * 9) / 5 + 32;

      const c1 = -42.379;
      const c2 = 2.04901523;
      const c3 = 10.14333127;
      const c4 = -0.22475541;
      const c5 = -0.00683783;
      const c6 = -0.05481717;
      const c7 = 0.00122874;
      const c8 = 0.00085282;
      const c9 = -0.00000199;

      const heatIndexF =
        c1 +
        c2 * tempF +
        c3 * humid +
        c4 * tempF * humid +
        c5 * tempF * tempF +
        c6 * humid * humid +
        c7 * tempF * tempF * humid +
        c8 * tempF * humid * humid +
        c9 * tempF * tempF * humid * humid;

      const heatIndexC = ((heatIndexF - 32) * 5) / 9;
      return Math.round(heatIndexC);
    }
    // 온도가 10°C 이하일 때: Wind Chill 사용
    else if (temp <= 10) {
      const windKmh = wind * 3.6;

      if (windKmh >= 4.8) {
        const windChill =
          13.12 +
          0.6215 * temp -
          11.37 * Math.pow(windKmh, 0.16) +
          0.3965 * temp * Math.pow(windKmh, 0.16);
        return Math.round(windChill);
      } else {
        return Math.round(temp);
      }
    }
    // 중간 온도대: 습도 기반 보정
    else {
      let adjustment = 0;

      if (humid >= 70) {
        adjustment = (humid - 70) * 0.1;
      } else if (humid <= 30) {
        adjustment = (30 - humid) * -0.05;
      }

      const windAdjustment = wind * -0.5;
      const feelsLike = temp + adjustment + windAdjustment;
      return Math.round(feelsLike);
    }
  };

  // 체감온도 계산
  const feelsLikeTemperature = calculateFeelsLike(
    weatherData.temperature,
    weatherData.humidity,
    weatherData.wind
  );

  const textContent =
    textData || "실내 환경과 날씨 정보를 실시간으로 확인하세요.";

  // 모드 변경 핸들러 추가
  const handleModeChange = (mode) => {
    console.log("디스플레이 모드 변경:", mode);
    // 여기에 모드 변경 로직 추가 가능
  };

  return (
    <StyledMainContainer
      orientation={orientation}
      isFixedMode={isFixedMode}
      displayWidth={displayWidth}
      displayHeight={displayHeight}
      themeMode={themeMode}
    >
      <Header>
        <TitleContainer>
          <TemplateCategory>{designConcept}</TemplateCategory>
          <HeaderTitle>{title || "미리보기"}</HeaderTitle>
        </TitleContainer>
        <Button
          Primary
          Large
          Fill
          onClick={onClose}
          style={{ position: "absolute", right: "32px" }}
        >
          미리보기 종료하기
        </Button>
      </Header>

      {/* 사이즈 영역 */}
      {/* <StyledSizeAreaContainer>
        <MoleculeSizeArea
          title="내 디스플레이"
          width={displayWidth.toString()}
          height={displayHeight.toString()}
        />
      </StyledSizeAreaContainer> */}

      <ContentWrapper>
        {/* 메인 패널 */}
        <MainPanel orientation={orientation} themeMode={themeMode}>
          {/* 헤더 */}
          <HeaderContainer orientation={orientation}>
            <TitleSection>
              <MainTitle themeMode={themeMode}>
                {sensorSerialData.title}
              </MainTitle>
            </TitleSection>
            <DateTimeSection orientation={orientation}>
              <DateContainer>
                <DateRow>
                  <DateText themeMode={themeMode}>{month}월</DateText>
                  <DateText themeMode={themeMode}>{day}일</DateText>
                </DateRow>
                <TimeText themeMode={themeMode}>
                  {hours}:{minutes}:{seconds}
                </TimeText>
              </DateContainer>
            </DateTimeSection>
          </HeaderContainer>

          {/* 센서 그리드 */}
          <SensorGrid orientation={orientation}>
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={
                    sensorData.temperature === "-" ? 0 : sensorData.temperature
                  }
                  unit="°C"
                  label="온도"
                  minValue={-10}
                  maxValue={100}
                  goodRange={[15, 32]}
                  normalRange={[-10, 14]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={sensorData.ozone === "-" ? 0 : sensorData.ozone}
                  unit="ppm"
                  label="오존"
                  minValue={0}
                  maxValue={0.2}
                  goodRange={[0, 0.03]}
                  normalRange={[0.03, 0.06]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={sensorData.humidity === "-" ? 0 : sensorData.humidity}
                  unit="%"
                  label="습도"
                  minValue={0}
                  maxValue={100}
                  goodRange={[40, 70]}
                  normalRange={[0, 39]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={sensorData.dust === "-" ? 0 : sensorData.dust}
                  unit="㎍/㎥"
                  label="미세먼지"
                  minValue={0}
                  maxValue={150}
                  goodRange={[0, 30]}
                  normalRange={[31, 80]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={sensorData.voc === "-" ? 0 : sensorData.voc}
                  unit="ppm"
                  label="VOC"
                  minValue={0}
                  maxValue={1000}
                  goodRange={[0, 200]}
                  normalRange={[201, 500]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
            <SensorSeparator themeMode={themeMode} />
            <SensorItem>
              <GaugeWrapper>
                <AtomsGauge
                  value={sensorData.co2 === "-" ? 0 : sensorData.co2}
                  unit="ppm"
                  label="이산화탄소"
                  minValue={0}
                  maxValue={3000}
                  goodRange={[0, 800]}
                  normalRange={[801, 1500]}
                  showStatus={true}
                  themeMode={themeMode}
                />
              </GaugeWrapper>
            </SensorItem>
          </SensorGrid>
        </MainPanel>

        {/* 날씨 패널 */}
        <WeatherPanel themeMode={themeMode}>
          <NewWeatherContentWrapper orientation={orientation}>
            {/* 첫 번째 묶음: 메인 날씨 정보 */}
            <MainWeatherGroup>
              <MainWeatherIcon
                src={getWeatherIconImage(currentWeatherIcon)}
                alt={getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
              />
              <WeatherInfoContainer>
                <WeatherStatus themeMode={themeMode}>
                  {getWeatherStatus(weatherForecastData.sky ? weatherForecastData.sky : weatherForecastData.weatherMain)}
                </WeatherStatus>
                <MainTemperatureContainer>
                  <MainTemperatureNumber themeMode={themeMode}>
                    {weatherData.temperature}
                  </MainTemperatureNumber>
                  <MainTemperatureUnit themeMode={themeMode}>
                    °C
                  </MainTemperatureUnit>
                </MainTemperatureContainer>
              </WeatherInfoContainer>
              <MinMaxTemperatureContainer>
                <MinMaxTemperature themeMode={themeMode}>
                  최저 {weatherForecastData.minTemperature}°
                </MinMaxTemperature>
                <MinMaxTemperature themeMode={themeMode}>
                  최고 {weatherForecastData.maxTemperature}°
                </MinMaxTemperature>
              </MinMaxTemperatureContainer>
            </MainWeatherGroup>

            {/* 두 번째 묶음: 상세 날씨 데이터 */}
            <WeatherDataGroup orientation={orientation}>
              {/* 풍속 */}
              <WeatherDataItem>
                <WeatherDataIconContainer>
                  <WeatherIconContainer>
                    <WeatherIcon
                      src={getWeatherThemeIcon("windspeed", themeMode)}
                      alt="풍속"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel themeMode={themeMode}>풍속</WeatherLabel>
                </WeatherDataIconContainer>
                <WeatherDataValueContainer>
                  <WeatherValueNumber themeMode={themeMode}>
                    {weatherData.wind}
                  </WeatherValueNumber>
                  <WeatherValueUnit themeMode={themeMode}>m/s</WeatherValueUnit>
                </WeatherDataValueContainer>
              </WeatherDataItem>

              {/* 강수량 */}
              <WeatherDataItem>
                <WeatherDataIconContainer>
                  <WeatherIconContainer>
                    <WeatherIcon
                      src={getWeatherThemeIcon("precipitation", themeMode)}
                      alt="강수량"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel themeMode={themeMode}>강수량</WeatherLabel>
                </WeatherDataIconContainer>
                <WeatherDataValueContainer>
                  <WeatherValueNumber themeMode={themeMode}>
                    {weatherData.precipitation}
                  </WeatherValueNumber>
                  <WeatherValueUnit themeMode={themeMode}>
                    mm/h
                  </WeatherValueUnit>
                </WeatherDataValueContainer>
              </WeatherDataItem>

              {/* 습도 */}
              <WeatherDataItem>
                <WeatherDataIconContainer>
                  <WeatherIconContainer>
                    <WeatherIcon
                      src={getWeatherThemeIcon("humidity", themeMode)}
                      alt="습도"
                    />
                  </WeatherIconContainer>
                  <WeatherLabel themeMode={themeMode}>습도</WeatherLabel>
                </WeatherDataIconContainer>
                <WeatherDataValueContainer>
                  <WeatherValueNumber themeMode={themeMode}>
                    {weatherData.humidity}
                  </WeatherValueNumber>
                  <WeatherValueUnit themeMode={themeMode}>%</WeatherValueUnit>
                </WeatherDataValueContainer>
              </WeatherDataItem>
            </WeatherDataGroup>
          </NewWeatherContentWrapper>
        </WeatherPanel>

        {/* 하단 메시지 */}
        <BottomMessage ref={messageContainerRef} themeMode={themeMode}>
          <MessageIcon themeMode={themeMode} />
          <MessageTextContainer>
            <MessageText
              ref={messageTextRef}
              isOverflowing={isTextOverflowing}
              data-text={textContent}
              themeMode={themeMode}
            >
              {textContent}
            </MessageText>
          </MessageTextContainer>
        </BottomMessage>
      </ContentWrapper>

      {/* 플로팅 모드 선택 버튼 */}
      {/* <StyledFloatingButtonContainer>
        <MoleculeModeFloating onModeChange={handleModeChange} />
      </StyledFloatingButtonContainer> */}
    </StyledMainContainer>
  );
};

export default OrganismInfoDisplayViewCustomPreview;

// styled-components 추가
const Header = styled.div`
  width: 100%;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 32px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
`;

const TitleContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  gap: 16px;
  left: 50%;
  transform: translateX(-50%);
`;

const TemplateCategory = styled.div`
  color: ${palette.primary};
  font-weight: 500;
  background-color: ${palette.primaryLightest};
  padding: 3px 8px;
  border-radius: 2px;
`;

const HeaderTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;

// 사이즈 영역 컨테이너
const StyledSizeAreaContainer = styled.div`
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 10000;
`;

// Main Container with theme support
const StyledMainContainer = styled.div`
  ${({ isFixedMode, displayWidth, displayHeight }) =>
    isFixedMode
      ? `
    /* 고정 모드: 정확한 픽셀 크기로 고정 */
    width: ${displayWidth}px;
    height: ${displayHeight}px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 10000;
  `
      : `
    /* 반응형 모드 또는 미리보기 모드: 기존과 동일 */
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10000;
  `}

  background: url(${qhdBackground}) center center;
  background-size: cover;
  // background: #1f1f1f; 

  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-family: Pretendard, Arial, sans-serif;
  box-sizing: border-box;

  padding: ${r(48)};

  @media (min-aspect-ratio: 21/9) {
    padding: ${r(24)} ${r(96)};
  }

  @media (max-aspect-ratio: 4/3) {
    padding: ${r(96)} ${r(24)};
  }

  @media (max-aspect-ratio: 9/16) {
    padding: ${r(120)} ${r(16)};
  }
  @media (max-aspect-ratio: 9/21) {
    padding: ${r(144)} ${r(12)};
  }

  @media (min-aspect-ratio: 32/9) {
    padding: ${r(12)} ${r(120)};
  }

  @media (min-aspect-ratio: 48/9) {
    padding: ${r(8)} ${r(144)};
  }

  ${({ orientation }) =>
    orientation === "portrait"
      ? `
    overflow-y: auto;
    overflow-x: hidden;
    align-items: flex-start;
  `
      : `
    overflow: hidden;
  `}
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${r(20)};
  min-height: 0;
  --font-scaler: ${r(19.2)};
  padding-top: 104px; /* Header 56px + MoleculeSizeArea 48px */

  @media (min-aspect-ratio: 21/9) {
    gap: ${r(15)};
  }
  @media (min-aspect-ratio: 32/9) {
    gap: ${r(12)};
  }

  @media (min-aspect-ratio: 48/9) {
    gap: ${r(8)};
  }

  @media (max-aspect-ratio: 9/16) {
    gap: ${r(24)};
  }

  @media (max-aspect-ratio: 9/21) {
    gap: ${r(28)};
  }
`;

const MainPanel = styled.div`
  flex: 3.4;
  display: flex;
  flex-direction: column;
  padding: ${r(30)};
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("MainPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: ${r(20)};
  margin: ${r(10)};
  outline: 3px
    ${({ themeMode }) => getThemeColor("MainPanelOutline", themeMode)} solid;
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  min-height: 0;
  overflow: visible;
  flex-shrink: 1;

  @media (min-aspect-ratio: 21/9) {
    padding: ${r(20)};
    margin: ${r(8)};
  }

  @media (min-aspect-ratio: 32/9) {
    padding: ${r(15)};
    margin: ${r(6)};
  }

  @media (min-aspect-ratio: 48/9) {
    padding: ${r(10)};
    margin: ${r(4)};
  }

  @media (max-aspect-ratio: 9/16) {
    padding: ${r(36)};
    margin: ${r(12)};
  }

  @media (max-aspect-ratio: 9/21) {
    padding: ${r(42)};
    margin: ${r(14)};
  }

  @media (max-aspect-ratio: 1/1) {
    border-radius: ${rv(20)};
    margin: ${rv(5)};
    padding: ${rv(15)};
  }
`;

const HeaderContainer = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
  min-height: ${r(115.2)};
  margin-bottom: ${r(24)};
  padding: 0;
  flex-direction: ${({ orientation }) =>
    orientation === "portrait" ? "column" : "row"};
  ${({ orientation }) =>
    orientation === "portrait"
      ? `
    justify-content: flex-start;
    gap: ${r(19.2)};
  `
      : ``}

  @media (min-aspect-ratio: 11/5) {
    margin-bottom: ${r(48)};
  }

  @media (max-aspect-ratio: 6/5) {
    margin-bottom: ${r(24)};
  }

  @media (max-aspect-ratio: 4/3) {
    margin-bottom: ${r(16)};
  }

  @media (max-aspect-ratio: 1/1) {
    ${({ orientation }) =>
      orientation === "portrait"
        ? `
          gap: ${rv(5)};
        `
        : ``}
  }
`;

const TitleSection = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${r(9.6)};
  display: flex;
  padding: ${r(38.4)} ${r(38.4)} 0 ${r(38.4)};

  @media (min-aspect-ratio: 2.2/1) {
    gap: ${(9.6 / 1920) * 100}vw;
    padding: ${(25 / 1920) * 100}vw ${(38.4 / 1920) * 100}vw 0
      ${(38.4 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3.5/1) {
    padding: ${(15 / 1920) * 100}vw ${(38.4 / 1920) * 100}vw 0
      ${(38.4 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 4/1) {
    padding: ${(10 / 1920) * 100}vw ${(38.4 / 1920) * 100}vw 0
      ${(38.4 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    padding: ${rv(20)} ${rv(20)} 0 ${rv(20)};
    gap: ${rv(5)};
  }
`;

const MainTitle = styled.h1`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(57.6 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }
`;

const DateTimeSection = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: ${({ orientation }) =>
    orientation === "portrait" ? "flex-start" : "flex-end"};
  gap: ${r(3.84)};
  display: flex;

  ${({ orientation }) =>
    orientation === "portrait"
      ? `
        padding: 0 0 0 ${r(38.4)};
        margin-top: ${r(-45)};
      `
      : `
        padding: ${r(38.4)} 0 0 ${r(38.4)};
  `}

  @media (min-aspect-ratio: 2.2/1) {
    gap: ${(3.84 / 1920) * 100}vw;
    ${({ orientation }) =>
      orientation === "portrait"
        ? `
          padding: 0 0 0 ${(38.4 / 1920) * 100}vw;
          margin-top: ${(-45 / 1920) * 100}vw;
        `
        : `
          padding: ${(25 / 1920) * 100}vw 0 0 ${(38.4 / 1920) * 100}vw;
    `}
  }

  @media (min-aspect-ratio: 3.5/1) {
    ${({ orientation }) =>
      orientation === "landscape"
        ? `
          padding: ${(15 / 1920) * 100}vw 0 0 ${(38.4 / 1920) * 100}vw;
        `
        : ``}
  }

  @media (min-aspect-ratio: 4/1) {
    ${({ orientation }) =>
      orientation === "landscape"
        ? `
          padding: ${(10 / 1920) * 100}vw 0 0 ${(38.4 / 1920) * 100}vw;
        `
        : ``}
  }

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(2)};
    ${({ orientation }) =>
      orientation === "portrait"
        ? `
          padding: 0 0 0 ${rv(20)};
          margin-top: ${rv(-12)};
        `
        : `
          padding: ${rv(20)} 0 0 ${rv(20)};
    `}
  }
`;

const DateContainer = styled.div`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  gap: 0;
  width: 100%;
`;

const DateRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${r(13.44)};
  display: flex;
`;

const DateText = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2.05 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(34.56 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }
`;

const TimeText = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2.05 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;
  width: ${r(200)};
  text-align: center;
  flex-shrink: 0;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(34.56 / 1920) * 100}vw;
    width: ${(200 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
    width: ${rv(100)};
  }
`;

const SensorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${r(16)};
  grid-template-rows: auto;
  place-items: stretch;
  width: 100%;
  height: auto;
  flex: 1;
  padding: 0;
  justify-content: center;
  align-items: center;
  min-height: 0;
  flex-shrink: 1;

  @media (min-aspect-ratio: 2.2/1) {
    gap: ${(16 / 1920) * 100}vw;
  }

  /* Grid positioning rules for different layouts */
  > *:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }
  > *:nth-child(2) {
    display: none;
  }
  > *:nth-child(3) {
    grid-column: 2;
    grid-row: 1;
  }
  > *:nth-child(4) {
    display: none;
  }
  > *:nth-child(5) {
    grid-column: 3;
    grid-row: 1;
  }
  > *:nth-child(6) {
    display: none;
  }
  > *:nth-child(7) {
    grid-column: 4;
    grid-row: 1;
  }
  > *:nth-child(8) {
    display: none;
  }
  > *:nth-child(9) {
    grid-column: 5;
    grid-row: 1;
  }
  > *:nth-child(10) {
    display: none;
  }
  > *:nth-child(11) {
    grid-column: 6;
    grid-row: 1;
  }

  @media (max-aspect-ratio: 6/5) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: ${r(14)};
    justify-content: center;
    align-items: center;

    > *:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    > *:nth-child(3) {
      grid-column: 2;
      grid-row: 1;
    }
    > *:nth-child(5) {
      grid-column: 3;
      grid-row: 1;
    }
    > *:nth-child(7) {
      grid-column: 1;
      grid-row: 2;
    }
    > *:nth-child(9) {
      grid-column: 2;
      grid-row: 2;
    }
    > *:nth-child(11) {
      grid-column: 3;
      grid-row: 2;
    }
  }

  @media (max-aspect-ratio: 0.75) {
    grid-template-columns: 1fr 1fr !important;
    grid-template-rows: repeat(3, auto) !important;
    gap: ${r(8)} !important;
    justify-content: center !important;
    align-items: center !important;
    justify-items: center !important;
    width: 100% !important;
    margin: 0 auto !important;
    place-items: center !important;

    > *:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    > *:nth-child(3) {
      grid-column: 2;
      grid-row: 1;
    }
    > *:nth-child(5) {
      grid-column: 1;
      grid-row: 2;
    }
    > *:nth-child(7) {
      grid-column: 2;
      grid-row: 2;
    }
    > *:nth-child(9) {
      grid-column: 1;
      grid-row: 3;
    }
    > *:nth-child(11) {
      grid-column: 2;
      grid-row: 3;
    }
  }

  @media (max-aspect-ratio: 1/2) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: ${r(10)};
    justify-content: center;
    align-items: center;

    > *:nth-child(even) {
      display: none;
    }
    > * {
      grid-column: unset;
      grid-row: unset;
    }
  }
`;

const SensorItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${r(4)};
  width: 100%;
  height: auto;
  padding: ${r(4)};
  white-space: nowrap;
  text-align: center;
  box-sizing: border-box;
  min-height: 0;

  > * {
    align-self: center;
    text-align: center;
  }

  @media (min-aspect-ratio: 2.2/1) {
    gap: ${(4 / 1920) * 100}vw;
    padding: ${(4 / 1920) * 100}vw;
  }
`;

const WeatherPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    136deg,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient01", themeMode)}
      0%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient02", themeMode)}
      50%,
    ${({ themeMode }) =>
        getThemeColor("WeatherPanelBackgroundLinearGradient03", themeMode)}
      100%
  );
  border-radius: ${r(20)};
  margin: ${r(10)};
  outline: 3px
    ${({ themeMode }) => getThemeColor("WeatherPanelOutline", themeMode)} solid;
  outline-offset: -3px;
  backdrop-filter: blur(12px);
  padding: ${r(60)};
  min-height: 0;
  overflow: hidden;
  flex-shrink: 1;

  @media (min-aspect-ratio: 2.2/1) {
    padding: ${r(60)} ${(120 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) {
    padding: ${r(50)};
    margin: ${r(8)};
  }

  @media (min-aspect-ratio: 32/9) {
    padding: ${r(45)};
    margin: ${r(6)};
  }

  @media (min-aspect-ratio: 48/9) {
    padding: ${r(40)};
    margin: ${r(4)};
  }

  @media (max-aspect-ratio: 9/16) {
    padding: ${r(30)};
    margin: ${r(12)};
  }

  @media (max-aspect-ratio: 9/21) {
    padding: ${r(25)};
    margin: ${r(14)};
  }

  @media (max-aspect-ratio: 1/1) {
    border-radius: ${rv(20)};
    margin: ${rv(5)};
    padding: ${rv(15)};
  }
`;

const WeatherIcon = styled.img`
  width: ${r(64)};
  height: ${r(64)};

  @media (min-aspect-ratio: 2.2/1) {
    width: ${(64 / 1920) * 100}vw;
    height: ${(64 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    width: ${rv(32)};
    height: ${rv(32)};
  }
`;

const WeatherIconContainer = styled.div`
  width: ${r(64)};
  height: ${r(64)};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-aspect-ratio: 2.2/1) {
    width: ${(55 / 1920) * 100}vw;
    height: ${(55 / 1920) * 100}vw;
  }

  > * {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
  }

  @media (max-aspect-ratio: 1/1) {
    width: ${rv(32)};
    height: ${rv(32)};
  }
`;

const WeatherLabel = styled.div`
  color: ${({ themeMode }) => getThemeColor("WeatherLabelColor", themeMode)};
  font-size: calc(1.6 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(28 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }
`;

const WeatherValueNumber = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2.5 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.2;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(42 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }
`;

const WeatherValueUnit = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(1.6 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 500;
  line-height: 1.2;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(28 / 1920) * 100}vw;
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }
`;

const BottomMessage = styled.div`
  padding: ${r(15)};
  background: ${({ themeMode }) =>
    getThemeColor("bottomMessageBackground", themeMode)};
  border-radius: ${r(20)};
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  gap: ${r(15)};
  flex-shrink: 0;
  margin: ${r(10)};

  @media (max-aspect-ratio: 1/1) {
    padding: ${rv(8)};
    border-radius: ${rv(20)};
    gap: ${rv(8)};
    margin: ${rv(5)};
  }
`;

const MessageIcon = styled.div`
  width: ${r(28.8)};
  height: ${r(28.8)};
  background: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  border-radius: 50%;

  @media (max-aspect-ratio: 1/1) {
    width: ${rv(15)};
    height: ${rv(15)};
  }
`;

const MessageTextContainer = styled.div`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
`;

const MessageText = styled.div`
  font-size: calc(1.8 * var(--font-scaler));
  font-weight: 600;
  white-space: nowrap;
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }

  ${({ isOverflowing }) =>
    isOverflowing
      ? css`
          display: inline-block;
          will-change: transform;
          animation: ${marqueeAnimation} 15s linear infinite;
          position: relative;

          &::after {
            content: attr(data-text);
            position: absolute;
            left: 100%;
            top: 0;
            padding-left: 4em;
            white-space: nowrap;
          }
        `
      : css`
          overflow: visible;
        `}
`;

const StyledLine653 = styled.div`
  width: ${r(5)};
  height: ${r(117)};
  opacity: 0.6;
  background: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  align-self: center;

  @media (min-aspect-ratio: 3/1) {
    width: ${r(3)};
    height: ${r(70)};
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    width: ${r(4)};
    height: ${r(80)};
  }

  @media (max-aspect-ratio: 2/1) and (min-aspect-ratio: 6/5) {
    width: ${r(4.8)};
    height: ${r(113)};
  }

  @media (max-aspect-ratio: 6/5) and (min-aspect-ratio: 0.751) {
    width: ${r(4.7)};
    height: ${r(113)};
  }

  @media (max-aspect-ratio: 0.75) {
    width: ${r(4)} !important;
    height: ${r(90)} !important;
  }

  @media (max-aspect-ratio: 0.35) {
    width: ${r(3.6)} !important;
    height: ${r(81)} !important;
  }

  @media (max-aspect-ratio: 1/2) {
    width: ${r(5)};
    height: ${r(100)};
  }

  @media (max-aspect-ratio: 1/1) {
    width: ${rv(6)};
    height: ${rv(130)};
  }
`;

const SensorSeparator = ({ themeMode }) => {
  return <StyledLine653 themeMode={themeMode} />;
};

const GaugeWrapper = styled.div`
  width: 80%;
  height: 80%;
  max-width: ${r(104)};
  max-height: ${r(104)};
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    transform: scale(0.7);
    transform-origin: center center;
  }

  @media (min-aspect-ratio: 2.2/1) {
    > * {
      transform: scale(0.9);
    }
  }

  @media (min-aspect-ratio: 2.5/1) {
    > * {
      transform: scale(1.1);
    }
  }

  @media (min-aspect-ratio: 3/1) {
    width: 60%;
    height: 60%;
    max-width: ${r(78)};
    max-height: ${r(78)};
    > * {
      transform: scale(1.3);
    }
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    width: 70%;
    height: 70%;
    max-width: ${r(87)};
    max-height: ${r(87)};
    > * {
      transform: scale(1.1);
    }
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    width: 75%;
    height: 75%;
    max-width: ${r(115)};
    max-height: ${r(115)};
    > * {
      transform: scale(0.9);
    }
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    width: 80%;
    height: 80%;
    max-width: ${r(135)};
    max-height: ${r(135)};
    > * {
      transform: scale(0.85);
    }
  }

  @media (max-aspect-ratio: 2/1) and (min-aspect-ratio: 6/5) {
    width: 75%;
    height: 75%;
    max-width: ${r(145)};
    max-height: ${r(145)};
    > * {
      transform: scale(0.8);
    }
  }

  @media (max-aspect-ratio: 6/5) and (min-aspect-ratio: 0.751) {
    width: 60%;
    height: 60%;
    max-width: ${r(97)};
    max-height: ${r(97)};
    > * {
      transform: scale(0.6);
    }
  }

  @media (max-aspect-ratio: 0.75) {
    width: 55% !important;
    height: 55% !important;
    max-width: ${r(115)} !important;
    max-height: ${r(115)} !important;
    > * {
      transform: scale(0.55) !important;
    }
  }

  @media (max-aspect-ratio: 0.35) {
    width: 49.5% !important;
    height: 49.5% !important;
    max-width: ${r(104)} !important;
    max-height: ${r(104)} !important;
    > * {
      transform: scale(0.495) !important;
    }
  }

  @media (max-aspect-ratio: 1/2) {
    width: 60%;
    height: 60%;
    max-width: ${r(125)};
    max-height: ${r(125)};
    > * {
      transform: scale(0.6);
    }
  }

  @media (max-aspect-ratio: 1/1) {
    width: 70%;
    height: 70%;
    max-width: ${rv(50)};
    max-height: ${rv(50)};
    > * {
      transform: scale(0.65);
    }
  }

  @media (max-aspect-ratio: 2/3) {
    width: 60%;
    height: 60%;
    max-width: ${rv(48)};
    max-height: ${rv(48)};
    > * {
      transform: scale(0.55);
    }
  }
`;

const NewWeatherContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    gap: 0;
    justify-content: space-between;
  `
      : `
    gap: ${r(30)};
    justify-content: center;
  `}

  align-items: center;
  width: 100%;
  min-height: 0;
  flex-shrink: 1;

  @media (max-aspect-ratio: 9/21) {
    flex-direction: column;
    gap: ${r(20)};
  }

  @media (max-height: 900px) {
    gap: max(${r(30)}, 18px);
  }

  @media (max-height: 700px) {
    gap: max(${r(30)}, 15px);
  }

  @media (max-height: 500px) {
    gap: max(${r(30)}, 12px);
  }
`;

const MainWeatherGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${r(30)};
  justify-content: flex-start;

  @media (min-aspect-ratio: 2.2/1) {
    gap: ${(20 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    gap: ${r(20)};
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    gap: ${(15 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    gap: ${r(25)};
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    gap: ${(18 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    gap: ${r(30)};
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    gap: ${(22 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    gap: ${r(35)};
  }

  @media (max-aspect-ratio: 9/21) {
    gap: ${r(35)};
  }

  @media (max-height: 900px) {
    gap: max(${r(30)}, 18px);
  }

  @media (max-height: 700px) {
    gap: max(${r(30)}, 15px);
  }

  @media (max-height: 500px) {
    gap: max(${r(30)}, 12px);
  }
`;

const WeatherDataGroup = styled.div`
  ${({ orientation }) =>
    orientation === "landscape"
      ? `
    display: contents;
  `
      : `
    display: flex;
    flex-direction: row;
    gap: ${r(25)};
    justify-content: center;
    align-items: center;
    
    @media (max-aspect-ratio: 456/917) and (min-aspect-ratio: 394/917) {
      flex-direction: column;
      gap: ${r(15)};
    }
  `}
`;

const MainWeatherIcon = styled.img`
  width: ${r(140)};
  height: ${r(140)};

  @media (min-aspect-ratio: 2.2/1) {
    width: ${(150 / 1920) * 100}vw;
    height: ${(150 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    width: ${r(100)};
    height: ${r(100)};
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    width: ${(110 / 1920) * 100}vw;
    height: ${(110 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    width: ${r(120)};
    height: ${r(120)};
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    width: ${(130 / 1920) * 100}vw;
    height: ${(130 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    width: ${r(140)};
    height: ${r(140)};
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    width: ${(145 / 1920) * 100}vw;
    height: ${(145 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    width: ${r(160)};
    height: ${r(160)};
  }

  @media (max-aspect-ratio: 9/16) {
    width: ${r(160)};
    height: ${r(160)};
  }

  @media (max-aspect-ratio: 9/21) {
    width: ${r(180)};
    height: ${r(180)};
  }

  @media (max-aspect-ratio: 1/1) {
    width: ${rv(70)};
    height: ${rv(70)};
  }

  @media (max-height: 900px) {
    width: max(${r(140)}, 84px);
    height: max(${r(140)}, 84px);
  }

  @media (max-height: 700px) {
    width: max(${r(140)}, 70px);
    height: max(${r(140)}, 70px);
  }

  @media (max-height: 500px) {
    width: max(${r(140)}, 56px);
    height: max(${r(140)}, 56px);
  }
`;

const WeatherInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${r(8)};

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(4)};
  }

  @media (max-height: 900px) {
    gap: max(${r(8)}, 5px);
  }

  @media (max-height: 700px) {
    gap: max(${r(8)}, 4px);
  }

  @media (max-height: 500px) {
    gap: max(${r(8)}, 3px);
  }
`;

const WeatherStatus = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 500;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(35 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    font-size: calc(1.4 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(28 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    font-size: calc(1.6 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(32 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    font-size: calc(1.8 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(35 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    font-size: calc(2 * var(--font-scaler));
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }

  @media (max-height: 900px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 18px);
  }

  @media (max-height: 700px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 16px);
  }

  @media (max-height: 500px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 14px);
  }
`;

const MainTemperatureContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${r(4)};

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(2)};
  }

  @media (max-height: 900px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 700px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 500px) {
    gap: max(${r(4)}, 1px);
  }
`;

const MainTemperatureNumber = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(3.5 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 400;
  line-height: 1;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(68 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    font-size: calc(2.8 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(55 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    font-size: calc(3.1 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(60 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    font-size: calc(3.5 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(65 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    font-size: calc(3.8 * var(--font-scaler));
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }

  @media (max-height: 900px) {
    font-size: max(calc(3.5 * var(--font-scaler)), 35px);
  }

  @media (max-height: 700px) {
    font-size: max(calc(3.5 * var(--font-scaler)), 28px);
  }

  @media (max-height: 500px) {
    font-size: max(calc(3.5 * var(--font-scaler)), 24px);
  }
`;

const MainTemperatureUnit = styled.span`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(2 * var(--font-scaler));
  font-family: Poppins;
  font-weight: 500;
  line-height: 1;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(38 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    font-size: calc(1.6 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(30 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    font-size: calc(1.8 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(33 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    font-size: calc(2 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(36 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    font-size: calc(2.2 * var(--font-scaler));
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }

  @media (max-height: 900px) {
    font-size: max(calc(2 * var(--font-scaler)), 20px);
  }

  @media (max-height: 700px) {
    font-size: max(calc(2 * var(--font-scaler)), 16px);
  }

  @media (max-height: 500px) {
    font-size: max(calc(2 * var(--font-scaler)), 14px);
  }
`;

const MinMaxTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${r(4)};

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(2)};
  }

  @media (max-height: 900px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 700px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 500px) {
    gap: max(${r(4)}, 1px);
  }
`;

const MinMaxTemperature = styled.div`
  color: ${({ themeMode }) => getThemeColor("mainColor", themeMode)};
  font-size: calc(1.8 * var(--font-scaler));
  font-family: Pretendard;
  font-weight: 600;
  white-space: nowrap;

  @media (min-aspect-ratio: 2.2/1) {
    font-size: ${(32 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 3/1) {
    font-size: calc(1.4 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(25 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    font-size: calc(1.6 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(28 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    font-size: calc(1.8 * var(--font-scaler));
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) and (min-aspect-ratio: 2.2/1) {
    font-size: ${(30 / 1920) * 100}vw;
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    font-size: calc(2 * var(--font-scaler));
  }

  @media (max-aspect-ratio: 1/1) {
    --font-scaler: ${rv(10)};
  }

  @media (max-height: 900px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 18px);
  }

  @media (max-height: 700px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 15px);
  }

  @media (max-height: 500px) {
    font-size: max(calc(1.8 * var(--font-scaler)), 13px);
  }
`;

const WeatherDataItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${r(24)};
  width: auto;
  padding: ${r(8)};
  box-sizing: border-box;

  @media (max-aspect-ratio: 620/917) and (min-aspect-ratio: 457/917) {
    flex-direction: column;
    gap: ${r(12)};
    padding: ${r(6)};
  }

  @media (max-aspect-ratio: 456/917) and (min-aspect-ratio: 394/917) {
    flex-direction: row;
    gap: ${r(16)};
    padding: ${r(4)};
  }

  @media (min-aspect-ratio: 21/9) {
    gap: ${r(18)};
    padding: ${r(6)};
  }

  @media (min-aspect-ratio: 32/9) {
    gap: ${r(15)};
    padding: ${r(5)};
  }

  @media (min-aspect-ratio: 48/9) {
    gap: ${r(12)};
    padding: ${r(4)};
  }

  @media (min-aspect-ratio: 3/1) {
    gap: ${r(15)};
    padding: ${r(5)};
  }

  @media (min-aspect-ratio: 21/9) and (max-aspect-ratio: 3/1) {
    gap: ${r(18)};
    padding: ${r(6)};
  }

  @media (min-aspect-ratio: 2.2) and (max-aspect-ratio: 21/9) {
    gap: ${r(24)};
    padding: ${r(8)};
  }

  @media (min-aspect-ratio: 2/1) and (max-aspect-ratio: 2.2) {
    gap: ${r(28)};
    padding: ${r(10)};
  }

  @media (max-aspect-ratio: 9/21) {
    gap: ${r(35)};
    padding: ${r(12)};
  }

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(12)};
    padding: ${rv(4)};
  }

  @media (max-height: 900px) {
    gap: max(${r(24)}, 14px);
    padding: max(${r(8)}, 5px);
  }

  @media (max-height: 700px) {
    gap: max(${r(24)}, 12px);
    padding: max(${r(8)}, 4px);
  }

  @media (max-height: 500px) {
    gap: max(${r(24)}, 10px);
    padding: max(${r(8)}, 3px);
  }
`;

const WeatherDataIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${r(8)};

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(4)};
  }

  @media (max-height: 900px) {
    gap: max(${r(8)}, 5px);
  }

  @media (max-height: 700px) {
    gap: max(${r(8)}, 4px);
  }

  @media (max-height: 500px) {
    gap: max(${r(8)}, 3px);
  }
`;

const WeatherDataValueContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${r(4)};

  @media (max-aspect-ratio: 1/1) {
    gap: ${rv(2)};
  }

  @media (max-height: 900px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 700px) {
    gap: max(${r(4)}, 2px);
  }

  @media (max-height: 500px) {
    gap: max(${r(4)}, 1px);
  }
`;

// 플로팅 버튼 컨테이너
const StyledFloatingButtonContainer = styled.div`
  position: fixed;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  display: flex;
  justify-content: center;
  align-items: center;
`;
